import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { IResponseCollection } from '@core/shared/interfaces/response-collection.interface';
import { Region } from '@pages/servers/servers.module';

@Injectable({
  providedIn: 'root',
})
export class ServerApiService extends BaseApiService {
  private path = '/api/v1/server';

  async getLanding(params: any = {}): Promise<IResponseCollection<Region>> {
    return this.get(`${this.path}/landing`, params);
  }
}
